import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GenericCrudService } from './crud/generic-crud.service';
import { environment } from 'src/app/environments/environments';

@Injectable({
  providedIn: 'root',
})
export class DataDocumentService {
  constructor(private http: HttpClient, private crudService: GenericCrudService<any>) {}

  dataExist = false;
  qty = -1;
  loading = false; 
  dataSource: any[] = [];

  getData(url: string, queryParams: any): Observable<any[]> {
    let params = new HttpParams();
    for (let tag of queryParams.tags) {
      params = params.append('tags', tag.name);
    }

    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
       tags: queryParams.tags.map((tag: { name: any; }) => tag.name),
       IdDetalleTipoDocumento : queryParams.detalleTipoDocumentoValue,
       tipoDocumentoId: queryParams.tipoDocumentoId,
       IdCompany : queryParams.idCompany,
       IdApp : queryParams.idApp,
    };

    return this.http.post<any[]>(url, headers).pipe(
      tap((data: any[]) => {
        this.dataExist = data.length > 0;
        this.qty = data.length > 0 ? 1 : 0;
        this.loading = false;
      })
    );
  }

  getHistoricalDocumentsService(url: string, queryParams: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      id_document : queryParams.id_document,
    };

    return this.http.post<any[]>(url, headers).pipe(
      tap((data: any[]) => {
        this.dataExist = data.length > 0;
        this.qty = data.length > 0 ? 1 : 0;
        this.loading = false;
      })
    );
  }
}